/**
 * Created by Arif Topcu in 2019
 */

import ComplicationSelector from '@ls/grouping-complication-selector';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import SelectionState from 'state/selections/SelectionState';
import {setDefinition} from 'state/trackingError/actions';
import {selectDefinitions} from 'state/trackingError/selectors';
import TrackingErrorDefinition from 'state/trackingError/TrackingErrorDefinition';
import ComplicationComponent from './TrackingErrorComplication';

const TrackingErrorSelector = (props) => {
  const dispatch = useDispatch();
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const setDefinitionCallback = useCallback(
    (idx, definition) => dispatch(setDefinition(idx, definition)),
    [dispatch],
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinitionCallback}
      getDefaultDefinition={TrackingErrorDefinition.getDefault}
      ComplicationComponent={ComplicationComponent}
      btnTitle={'Tracking Error'}
      addMoreText={'Tracking Error Column'}
    />
  );
};

export default TrackingErrorSelector;
